<template>
  <settings-modal
    class="customize-columns-modal"
    :helper-visible="!hasSelected"
  >
    <template slot="heading">Customize columns</template>

    <template>
      <v-checkbox
        v-model="selectedAll"
        class="pb-2 t-select-all"
        color="primary"
        label="All"
        indeterminate
        @change="toggleSelectAll"
      />
      <v-checkbox
        v-for="(option, key) in columnOptions"
        :key="key"
        v-model="selectedColumns"
        class="t-regular-checkbox"
        color="primary"
        :label="option.name"
        :value="option.value"
      />
    </template>

    <template slot="actions">
      <v-btn
        class="font-weight-bold t-save"
        color="primary"
        medium
        flat
        :disabled="!hasSelected"
        @click="save"
      >save</v-btn>

      <v-btn
        class="font-weight-bold t-cancel"
        color="primary"
        medium
        flat
        @click="closeModal"
      >cancel</v-btn>
    </template>

    <template slot="helper">At least one field must be selected</template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_SETTINGS_UPDATE } from '@/events/settings'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'

  export default {
    name: 'CustomizeColumnsModal',
    components: {
      SettingsModal
    },
    data () {
      return {
        selectedAll: false,
        selectedColumns: []
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      tableName () {
        return this.modal.data.tableName
      },
      columnOptions () {
        return this.modal.data.columnOptions
      },
      defaultColumns () {
        return this.modal.data.defaultColumns
      },
      savedColumns () {
        return this.modal.data.savedColumns
      },
      hasSelected () {
        return this.selectedColumns.length > 0
      }
    },
    created () {
      this.selectedColumns = this.savedColumns.length > 0 ? [...this.savedColumns] : [...this.defaultColumns]
      this.selectedAll = this.selectedColumns.length === this.columnOptions.length
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      toggleSelectAll () {
        this.selectedColumns = this.selectedAll ? this.columnOptions.map(columnOption => columnOption.value) : []
      },
      save () {
        localStorage.setItem(this.tableName, JSON.stringify(this.selectedColumns))

        this.closeModal()
        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Settings has been successfully updated.' }
          })
        }, 100)

        this.$eventHub.$emit(EVENT_SETTINGS_UPDATE)
      }
    }
  }
</script>
